import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { publicAds, adClick, adImpression, resolveFileUrl } from '../lib/api';
import { Megaphone } from 'lucide-react';

export default function PromotedCard({ category }) {
  const [ad, setAd] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const list = await publicAds({ placement: 'row_promoted', category, limit: 5 });
        if (list && list.length) {
          const chosen = list[Math.floor(Math.random() * list.length)];
          setAd(chosen); adImpression(chosen.id);
        }
      } catch {}
    })();
  }, [category]);

  if (!ad) return null;

  const inner = (
    <div className="relative thumb" style={{ background: '#141418' }}>
      <img src={resolveFileUrl(ad.media_url) || 'https://images.unsplash.com/photo-1487958449943-2429e8be8625?w=900'} alt={ad.headline} />
      <div className="absolute inset-0" style={{ background: 'linear-gradient(0deg, rgba(0,0,0,0.8), rgba(0,0,0,0) 55%)' }} />
      <div className="absolute top-2 left-2 text-[10.5px] uppercase tracking-wider bg-black/65 border border-white/10 rounded-full px-2 py-0.5 flex items-center gap-1 text-[#ffcf52]"><Megaphone className="w-3 h-3" /> Promoted</div>
      <div className="absolute bottom-2 left-2 right-2 text-white">
        <div className="text-[14px] font-semibold line-clamp-2">{ad.headline}</div>
        {ad.body && <div className="text-[12px] text-white/70 line-clamp-1 mt-0.5">{ad.body}</div>}
      </div>
    </div>
  );

  if (ad.video_id) {
    return (
      <Link to={`/watch/${ad.video_id}`} onClick={() => adClick(ad.id)} className="block">
        {inner}
        <div className="mt-2 text-[13px] text-white/70">Sponsored • tap to watch</div>
      </Link>
    );
  }
  if (ad.link_url) {
    return (
      <a href={ad.link_url} target="_blank" rel="noreferrer" onClick={() => adClick(ad.id)} className="block">
        {inner}
        <div className="mt-2 text-[13px] text-white/70">Sponsored • external link</div>
      </a>
    );
  }
  return <div>{inner}</div>;
}
